const BACKGROUND_MUSIC_ENABLED_KEY = "backgroundMusicEnabled"

export const getBackgroundMusicEnabled = (): boolean => {
  const stored = localStorage.getItem(BACKGROUND_MUSIC_ENABLED_KEY)
  if (stored === null) return true
  return stored === "true"
}

export const setBackgroundMusicEnabled = (enabled: boolean) => {
  localStorage.setItem(BACKGROUND_MUSIC_ENABLED_KEY, String(enabled))
  window.dispatchEvent(
    new CustomEvent("background-music-preference-changed", {
      detail: enabled,
    })
  )
}

export const toggleBackgroundMusicEnabled = (): boolean => {
  const next = !getBackgroundMusicEnabled()
  setBackgroundMusicEnabled(next)
  return next
}
